
import { uses } from "~/data/disasterRecovery";

export default {
  data() {
    return {
      items: uses,
    };
  },
};
